import {
  // Fragment,
  useEffect,
  useMemo,
  // useState
} from "react";
import {
  createBrowserRouter,
  Link,
  // Navigate,
  Outlet,
  RouterProvider,
  ScrollRestoration,
  // useLocation,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
// import { Collapse } from "@material-tailwind/react";
// import Switch from "react-switch";
// import { Dialog, Transition } from "@headlessui/react";
// import FlyySDK from "flyy-web-sdk";
// import { flyy_partner_id, sdkWrapperURL } from "./utils/api-url-list";
import AuthProvider, { useAuth } from "./utils/auth";

// import Welcome from "./assets/images/welcome-img.svg";
// import Dimond from "./assets/images/Dimond.svg";
// import Coins from "./assets/images/coin.svg";
// import GoogleFit from "./assets/icons/google-fit-icon.svg";
// import DeviceIcon from "./assets/icons/smartphone-2-svgrepo-com.svg";
// import { ReactComponent as Menu } from "./assets/icons/Menu.svg";
// import { ReactComponent as Close } from "./assets/icons/Close.svg";
// import { ReactComponent as DashboardIcon } from "./assets/icons/Dashboard.svg";
// import { ReactComponent as MyAccountIcon } from "./assets/icons/MyAccount.svg";
// import { ReactComponent as TutorialIcon } from "./assets/icons/Tutorial.svg";
// import { ReactComponent as SupportIcon } from "./assets/icons/Support.svg";
// import { ReactComponent as LogoutIcon } from "./assets/icons/Logout.svg";
// import Tab3 from "./assets/images/tab-icon3.svg";

import AuthBypass from "./screens/AuthBypass";
import Login from "./screens/Login";
import TermsOfUSe from "./screens/TermsOfUse";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import BasicDetails from "./screens/BasicDetails";
import MyAccount from "./screens/MyAccount";
import Tutorial from "./screens/Tutorial";
import Support from "./screens/Support";
import Dashboard from "./screens/Dashboard";
import StartScan from "./screens/StartScan";
import SelectScanOption from "./screens/SelectScanOption";
// import SelectOption from "./screens/SelectOption";
import ScanInstructions from "./screens/ScanInstructions";
import CameraPermissionGuide from "./screens/CameraPermissionGuide";
// import SelectPosture from "./screens/SelectPosture";
import FaceScan from "./screens/FaceScan";
import FingerScan from "./screens/FingerScan";
import ScanResult from "./screens/ScanResult";
import Survey from "./screens/Survey";
import HeartHealth from "./screens/history/HeartHealth";
import BodyVitals from "./screens/history/BodyVitals";
import PhysioFitness from "./screens/history/PhysioFitness";
import StressIndex from "./screens/history/StressIndex";
import DetailHistory from "./screens/history/DetailHistory";
import Abha from "./screens/Abha";
import LabPackages from "./screens/LabPackages";
import DoctorList from "./screens/DoctorList";
import DoctorAppointment from "./screens/DoctorAppointment";
import Education from "./screens/Education";
import EducationDetails from "./screens/EducationDetails";
import WellnessProgram from "./screens/WellnessProgram";
import JoinProgram from "./screens/JoinProgram";
import Medication from "./screens/Medication";
import Nutrition from "./screens/Nutrition";
import Activity from "./screens/Activity";
import Walking from "./screens/Walking";
import WalkingDetails from "./screens/WalkingDetails";
import BMI from "./screens/BMI";
import MentalWellbing from "./screens/MentalWellbing";
import DailyWellbing from "./screens/DailyWellbing";
import WellbingDetails from "./screens/WellbingDetails";
import HealthHabbits from "./screens/HealthHabbits";
import HealthDetails from "./screens/HealthDetails";
import Reward from "./screens/Reward";
import LiveChat from "./screens/LiveChat";
import VitalsIndex from "./screens/VitalsIndex";
import DiabetesInsights from "./screens/DiabetesInsights";
import HeartHealthScore from "./screens/HeartHealthScore";
import MyCare from "./screens/MyCare";
// import BreathLab from "./screens/BreathLab";
import PackageList from "./screens/PackageList";
import PackageDetails from "./screens/PackageDetails";
import InsuranceList from "./screens/InsuranceList";
import MoodTracking from "./screens/MoodTracking";
// import TrakingSuccess from "./screens/TrakingSuccess";
// import ProgramTracking from "./screens/ProgramTracking";
// import BackPain from "./screens/BackPain";
// import PeriodCramps from "./screens/PeriodCramps";
// import MigrainePain from "./screens/MigrainePain";
// import AnalysisData from "./screens/AnalysisData";
import ScoreHistory from "./screens/ScoreHistory";
// import Headache from "./screens/Headache";
// import ShoulderPain from "./screens/ShoulderPain";
// import KneePain from "./screens/KneePain";
import MyHealth from "./screens/MyHealth";
import LabPackageDetail from "./screens/LabPackageDetail";
import DiscountCenter from "./screens/DiscountCenter";
import BmiHistory from "./screens/BmiHistory";
import MyMind from "./screens/MyMind";
import VitalsScore from "./screens/VitalsScore";
import HealthChallenge from "./screens/HealthChallenge";
import MoodInsight from "./screens/MoodInsight";
import MoodHistory from "./screens/MoodHistory";
import BetterSleep from "./screens/BetterSleep";
import BedtimeStory from "./screens/BedtimeStory";
import BedtimeMelody from "./screens/BedtimeMelody";
import RelaxingMusic from "./screens/RelaxingMusic";
import NutritionPackage from "./screens/NutritionPackage";
import BedtimeStretching from "./screens/BedtimeStretching";
import Wellbeing from "./screens/Wellbeing";
// import SelfCare from "./screens/SelfCare";
// import ManagingStress from "./screens/ManagingStress";
// import PersonalGrowth from "./screens/PersonalGrowth";
// import IncreasingWorkLife from "./screens/IncreasingWorkLife";
// import EmotionalResilience from "./screens/EmotionalResilience";
import RelaxationMusic from "./screens/RelaxationMusic";
import YogaMeditation from "./screens/YogaMeditation";
import VisualizationTranquility from "./screens/VisualizationTranquility";
import WellbeingContentDetails from "./screens/WellbeingContentDetails";
import ContentDetails from "./screens/ContentDetails";
import ContentTabs from "./screens/ContentTabs";
import NutritionPackageList from "./screens/NutritionPackageList";
import MindfulMoments from "./screens/MindfulMoments";
import FitnessPackage from "./screens/FitnessPackage";
import OurPricing from "./screens/OurPricing";
import MoodtrackStep from "./screens/MoodtrackStep";
import MyProfile from "./screens/MyProfile";
import InsurancePolicy from "./screens/InsurancePolicy";
import RelivePain from "./screens/RelivePain";
import NutrationList from "./screens/NutrationList";
import DYKList from "./screens/DYKList";
import DYKDetails from "./screens/DYKDetails";
import ConfigureAlerts from "./screens/ConfigureAlerts";
import SelectUserAlert from "./screens/SelectUserAlert";
import AlertSetting from "./screens/AlertSetting";
import SelectUser from "./screens/SelectUser";
import DiagnosticPackages from "./screens/DiagnosticPackages";
import RequestCallback from "./screens/RequestCallback";
import DigitalClinic from "./screens/DigitalClinic";
import Goal from "./screens/Goal";
import AddGoal from "./screens/AddGoal";
import SelectedGoal from "./screens/SelectedGoal";
import CognitiveScore from "./screens/CognitiveScore";
import CognitiveAssessments from "./screens/CognitiveAssessments";
import SimonTest from "./screens/SimonTest";
import SimonTestCircle from "./screens/SimonTestCircle";
import SimonScore from "./screens/SimonScore";
import ScoreDetails from "./screens/ScoreDetails";
import NutritionResults from "./screens/NutritionResults";
import NutritionReceipesList from "./screens/NutritionReceipesList";
import NutritinReceipeDetail from "./screens/NutritionReceipeDetail";
import WaterTracker from "./screens/WaterTracker";
import DownloadAPP from "./screens/Download";
import NotFound from "./screens/404";
import Referal from "./screens/Referal";
import NutrationHistory from "./screens/NutrationHistory";
import Vouchers from "./screens/Vouchers";
import DoctorConsultation from "./screens/DoctorConsultation";

const Header = () => {
  // const { pathname } = useLocation();
  const {
    // getToken,
    // logout,
    userData: {
      fname,
      // profile_id,
      // flyy_id
    },
  } = useAuth();
  // const [isOpen, setIsOpen] = useState(false);
  const greetingsText = useMemo(() => {
    const hourNow = new Date().getHours();
    return hourNow < 12
      ? "Good Morning"
      : hourNow < 17
      ? "Good Afternoon"
      : "Good Evening";
  }, []);

  // const viewRewards = () => {
  //   if (typeof window?.ReactNativeWebView?.postMessage === "function")
  //     window.ReactNativeWebView.postMessage(
  //       JSON.stringify({ event: "view-rewards", data: { userID: flyy_id } })
  //     );
  //   else {
  //     window.flyySDK?.openRewardsScreen({ fullScreen: true });
  //   }
  // };

  // const [open, setOpen] = useState(false);
  // const toggleOpen = () => setOpen((cur) => !cur);
  // const [active, setActive] = useState(false);
  // const [balance, setBalance] = useState(-1);

  // function handleChange(checked) {
  //   setActive(checked);
  // }

  // useEffect(() => {
  // (async () => {
  //   try {
  //     const token = await getToken();
  //     const flyySDK = new FlyySDK();
  //     const flyyTokenResp = await fetch(sdkWrapperURL("/flyy/user-token"), {
  //       method: "POST",
  //       headers: { "content-type": "application/json", Authorization: token },
  //       body: JSON.stringify({ profile_id }),
  //     });
  //     const flyyTokenRespJSON = await flyyTokenResp.json();
  //     if (flyyTokenRespJSON?.statusCode?.toString().startsWith("2")) {
  //       flyySDK.init(
  //         JSON.stringify({
  //           package_name: "com.careplix.one",
  //           partner_id: flyy_partner_id,
  //           ext_user_token: flyyTokenRespJSON.user_token,
  //           attachMode: "popup",
  //           // attachMode: "drawer",
  //           // attachMode: "fullscreen",
  //           environment: "STAGING",
  //         })
  //       );
  //       window.flyySDK = flyySDK;
  //     } else
  //       throw new Error(
  //         flyyTokenRespJSON.message ?? "Error in Fetching data"
  //       );
  //   } catch (err) {
  //     console.error(err);
  //   }
  // })();
  // (async () => {
  //   try {
  //     const token = await getToken();
  //     const walletCoins = await fetch(sdkWrapperURL("/flyy/get-balance"), {
  //       method: "POST",
  //       headers: { "content-type": "application/json", Authorization: token },
  //       body: JSON.stringify({}),
  //     });
  //     const res = await walletCoins.json();
  //     if (res?.statusCode?.toString().startsWith("2")) setBalance(res.coins);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // })();
  // }, [getToken, profile_id]);

  return (
    <main className="min-h-screen relative bg-primary text-white">
      {/* <Transition show={isOpen} as={Fragment}>
        <Dialog as={Fragment} onClose={() => setIsOpen(false)}>
          <Transition.Child
            className="fixed inset-0 bg-white/50"
            enter="duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="duration-300 delay-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Transition.Child
              as={Fragment}
              enter="delay-150 duration-200 transition-transform transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="duration-200 transition-transform transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel
                as="aside"
                className="min-h-full w-64 bg-white flex flex-col items-stretch"
              >
                <div className="flex items-start justify-between p-6">
                  <div className="w-40 text-white">
                    <Dialog.Title as="h3" className="text-sm">
                      {greetingsText}
                    </Dialog.Title>
                    <Dialog.Title
                      as="h2"
                      className="text-lg font-medium truncate"
                    >
                      {fname}
                    </Dialog.Title>
                  </div>
                  <button
                    className="flex-shrink-0 bg-primary p-1.5 rounded-full"
                    type="button"
                    onClick={() => setIsOpen(false)}
                  >
                    <Close className="h-5 w-5 text-white" />
                  </button>
                </div>
                <nav className="mt-4">
                  <ul className="space-y-4">
                    {[
                      {
                        to: "/",
                        label: "Dashboard",
                        icon: (
                          <DashboardIcon className="h-5 w-5 text-primary" />
                        ),
                      },
                      {
                        to: "/my-account",
                        label: "My Account",
                        icon: (
                          <MyAccountIcon className="h-5 w-5 text-primary" />
                        ),
                      },
                      {
                        to: "/tutorial",
                        label: "Tutorial",
                        icon: <TutorialIcon className="h-5 w-5 text-primary" />,
                      },
                      {
                        to: "/support",
                        label: "Support",
                        icon: <SupportIcon className="h-5 w-5 text-primary" />,
                      },
                    ].map((linkObj) => (
                      <li key={linkObj.to} className="pr-6">
                        <Link
                          to={linkObj.to}
                          className={`flex items-center space-x-4 py-2 px-6 rounded-r-full ${
                            pathname === linkObj.to
                              ? "bg-secondary/10"
                              : "bg-transparent"
                          } hover:bg-secondary/5`}
                          onClick={() => setIsOpen(false)}
                        >
                          {linkObj.icon}
                          <span className="text-primary text-xs">
                            {linkObj.label}
                          </span>
                        </Link>
                      </li>
                    ))}
                    <li className="flex flex-col">
                      <Link
                        to=""
                        className="flex items-center py-2 px-6 rounded-r-full"
                        onClick={toggleOpen}
                      >
                        <img
                          src={DeviceIcon}
                          width="20"
                          className="mr-5"
                          alt=""
                        />
                        <span className="text-primary text-xs">
                          {" "}
                          Connected Device
                        </span>
                      </Link>
                      <Collapse open={open}>
                        <div className="flex justify-between px-6 py-1">
                          {" "}
                          <p className="text-white text-xs pl-10 flex items-center">
                            <img
                              src={GoogleFit}
                              alt=""
                              width="10"
                              className="mr-3"
                            />{" "}
                            Google Fit
                          </p>{" "}
                          <Switch
                            onColor="#86d3ff"
                            onHandleColor="#2693e6"
                            handleDiameter={14}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            onChange={handleChange}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            checked={active}
                            height={10}
                            width={25}
                          />
                        </div>
                      </Collapse>
                    </li>
                    <li className="pr-6">
                      <button
                        type="button"
                        className="w-full flex items-center space-x-4 py-2 px-6 rounded-r-full hover:bg-error/5 active:bg-error/10"
                        onClick={() => {
                          setIsOpen(false);
                          logout();
                        }}
                      >
                        <LogoutIcon className="h-5 w-5 text-error" />
                        <span className="text-error text-xs">Logout</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </Dialog.Panel>
            </Transition.Child>
          </Transition.Child>
        </Dialog>
      </Transition> */}
      <header className="flex items-center justify-between p-6 text-white">
        <div>
          <h3 className="flex text-sm">{greetingsText}</h3>
          <h2 className="text-lg font-medium truncate">{fname}</h2>
        </div>
        {/* <div className="member flex items-center">
          <img src={Dimond} alt="Dimond img" className="header-icon" />
          <p className="dimond-text">
            Diamond <br />
            Member
          </p>
        </div> */}
        {/* <div className="flex items-center">
          <button className="flex items-center mr-4" onClick={viewRewards}>
            <img src={Coins} alt="coin img" className="header-icon" />
            <p className="coin-lineheight">
              <span className="coin-text">{balance < 0 ? "--" : balance}</span>
              <br />
              <span className="coin-subtext">Care Coins</span>
            </p>
          </button>

          <button
            className="flex-shrink-0"
            type="button"
            onClick={() => setIsOpen(true)}
          >
            <Menu className="h-6 w-6 text-white" />
          </button>
        </div> */}
        {/* <Link className="shrink-0" to="/add-goal">
          <span className="sr-only">Goal</span>
          <svg
            width="25"
            height="25"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.2344 2.35684C13.1152 2.79043 9.8416 4.30801 7.07383 7.07578C4.57344 9.5834 3.06309 12.568 2.47773 16.1523C2.3043 17.258 2.3043 19.7439 2.47773 20.8496C3.04141 24.3039 4.50117 27.2596 6.84258 29.7094C9.30684 32.2748 12.5082 33.9297 16.1504 34.5223C17.2416 34.6957 19.7275 34.6957 20.8477 34.5223C25.5232 33.7852 29.4906 31.227 32.0705 27.2885C33.299 25.424 34.1373 23.2127 34.5203 20.8496C34.701 19.7295 34.701 17.2508 34.5203 16.1523C34.3396 15.0756 34.1229 14.2301 33.9566 13.9482C33.6676 13.4713 32.8293 13.3123 32.3813 13.6375C31.8537 14.035 31.7887 14.4035 32.0416 15.5381C32.7498 18.725 32.2945 22.0637 30.7625 24.9471C29.3678 27.5848 27.3299 29.5721 24.6777 30.8873C22.7771 31.834 21.1512 32.2604 19.0771 32.3543C14.5822 32.5566 10.0945 30.432 7.4207 26.826C2.14531 19.7295 4.63125 9.74961 12.6094 5.95566C15.3627 4.64766 18.4629 4.29355 21.4258 4.9584C22.4158 5.17519 22.676 5.17519 22.9795 4.96562C23.5215 4.6043 23.6805 4.09121 23.4275 3.52031C23.2541 3.12285 23.0518 2.98555 22.4158 2.80488C21.4258 2.53027 20.2406 2.37852 18.8604 2.34961C18.1232 2.34238 17.3934 2.34238 17.2344 2.35684Z"
              fill="#663CC7"
            />
            <path
              d="M28.942 2.45123C28.7541 2.53795 27.952 3.28951 26.6223 4.63365C24.7723 6.50533 24.5771 6.72213 24.4326 7.10514C24.2592 7.58209 24.2447 8.03736 24.3604 9.10689C24.4109 9.50435 24.4254 9.85123 24.4109 9.87291C24.3893 9.89459 24.1797 9.78619 23.9484 9.64166C23.0018 9.03463 21.6648 8.51431 20.4074 8.26138C19.4463 8.07349 17.4084 8.08795 16.4617 8.29752C14.3154 8.76724 12.6605 9.66334 11.1646 11.1665C9.94336 12.3805 9.12676 13.703 8.59922 15.3073C8.23066 16.4491 8.13672 17.1067 8.13672 18.5014C8.13672 19.8962 8.23066 20.5538 8.59922 21.6956C9.12676 23.2999 9.94336 24.6223 11.1646 25.8364C12.6605 27.3395 14.3227 28.2356 16.4617 28.7053C17.4012 28.9149 19.4463 28.9294 20.4074 28.7415C22.532 28.3151 24.3242 27.3612 25.8346 25.8436C27.3377 24.3405 28.2338 22.6784 28.7035 20.5393C28.9275 19.5276 28.9275 17.4753 28.7035 16.4635C28.4289 15.1917 27.9375 13.9559 27.3594 13.0526C27.2148 12.8213 27.1064 12.6118 27.1281 12.5901C27.1498 12.5756 27.4967 12.5901 27.8941 12.6407C28.9637 12.7563 29.4189 12.7419 29.8959 12.5684C30.2789 12.4239 30.4957 12.2288 32.3674 10.3788C34.4197 8.3481 34.6799 8.02291 34.6871 7.56764C34.6871 7.2858 34.5209 6.91724 34.2824 6.70045C34.0367 6.4692 33.7621 6.41139 32.1723 6.23795C31.0377 6.12232 30.9221 6.09342 30.8932 5.96334C30.8715 5.88385 30.792 5.22623 30.7125 4.5108C30.5607 3.09439 30.5246 2.94264 30.2789 2.68248C29.9248 2.31392 29.4262 2.22721 28.942 2.45123ZM28.6529 6.80885C28.7469 7.90728 29.1154 8.25416 30.25 8.3481C30.5824 8.37701 30.8715 8.4276 30.8932 8.44928C30.9076 8.47818 30.4885 8.93346 29.9537 9.46822L28.9926 10.4294L27.923 10.3065C27.3377 10.2415 26.8463 10.1764 26.8318 10.162C26.8102 10.1475 26.7451 9.65611 26.6873 9.07076L26.5645 8.01568L27.5328 7.04732C28.1615 6.41861 28.5229 6.10787 28.5518 6.16568C28.5807 6.20904 28.624 6.50533 28.6529 6.80885ZM19.6775 11.6723C20.0244 11.7301 20.5664 11.8819 20.8988 11.9975C21.477 12.2071 22.4742 12.7491 22.4742 12.8503C22.4742 12.8792 21.9178 13.4573 21.2385 14.1366L20.0027 15.3723L19.627 15.235C17.7986 14.534 15.6523 15.7047 15.1393 17.6848C14.6695 19.4842 15.8186 21.3776 17.683 21.8618C19.533 22.346 21.4986 21.0885 21.9033 19.1735C22.0117 18.646 21.9539 17.851 21.766 17.3741L21.6287 16.9983L22.8861 15.7481L24.1436 14.4907L24.2809 14.6713C24.5049 14.9532 24.9746 15.9577 25.1336 16.4852C25.4805 17.6198 25.5166 19.0506 25.2275 20.1708C24.5699 22.7073 22.6188 24.6295 20.0461 25.2727C19.2873 25.4606 17.6324 25.4461 16.8592 25.2438C15.1176 24.7813 13.6217 23.719 12.6895 22.2809C11.2369 20.0335 11.2008 17.1428 12.5883 14.8881C14.077 12.4672 16.9025 11.1881 19.6775 11.6723Z"
              fill="#663CC7"
            />
          </svg>
        </Link> */}
        <Link className="shrink-0" to="/my-profile">
          <span className="sr-only">My Profile</span>
          <svg className="h-6 w-6" viewBox="0 0 26 25" fill="none">
            <path
              d="M11.0935 0.0807629C10.5259 0.231783 9.9844 0.617144 9.6824 1.09103C9.43246 1.4764 9.31791 1.83572 9.27105 2.35127C9.22418 2.84599 9.15649 2.99181 8.88052 3.1949C8.65142 3.36675 8.23486 3.34071 7.99534 3.14283C7.41736 2.67935 7.28719 2.59082 7.02684 2.49188C6.38638 2.25233 5.67823 2.27837 5.0586 2.5752C4.72015 2.73663 4.55873 2.86682 3.84017 3.58026C3.38196 4.02812 2.93416 4.51763 2.83522 4.66344C2.56967 5.06443 2.4447 5.49145 2.4447 6.01221C2.4447 6.70482 2.62174 7.14746 3.13723 7.75154C3.4913 8.16294 3.52254 8.51706 3.24137 8.85035C3.05392 9.07427 2.85605 9.1628 2.53843 9.1628C1.91359 9.1628 1.29396 9.42839 0.830537 9.89186C0.502498 10.2199 0.294219 10.5741 0.179665 11.0115C0.0651116 11.4489 0.0651116 13.5424 0.179665 13.9798C0.460842 15.0474 1.45537 15.8285 2.53843 15.8285C2.85605 15.8285 3.05392 15.917 3.24137 16.141C3.52775 16.4795 3.4861 16.8336 3.12681 17.2502C2.99143 17.4064 2.82481 17.6147 2.76233 17.7189C2.2989 18.474 2.32494 19.5624 2.83522 20.3279C2.93416 20.4737 3.38196 20.9632 3.84017 21.4111C4.57435 22.1349 4.71494 22.2547 5.07943 22.4265C5.48558 22.6192 5.5012 22.6244 6.11562 22.6244C6.72484 22.6244 6.75087 22.6192 7.13098 22.4369C7.34447 22.3328 7.65688 22.1297 7.82351 21.9839C8.25048 21.6037 8.60976 21.5621 8.96384 21.8589C9.16691 22.0308 9.26584 22.2651 9.26584 22.588C9.26584 23.1816 9.54181 23.817 9.98961 24.27C10.3176 24.5981 10.6717 24.796 11.1247 24.9158C11.4788 25.0095 13.5043 25.0251 13.9573 24.9418C14.9519 24.7543 15.7641 23.8899 15.8891 22.8744C15.9152 22.6505 15.9516 22.3901 15.962 22.2963C15.9985 22.0672 16.2588 21.7808 16.5035 21.7079C16.8003 21.6194 17.0242 21.6871 17.3419 21.9579C17.9875 22.5099 18.4197 22.6713 19.1851 22.64C19.659 22.6244 19.7423 22.6036 20.1224 22.4265C20.5025 22.2443 20.6223 22.1453 21.4345 21.3329C22.2468 20.5206 22.3458 20.4008 22.528 20.0206C22.705 19.6405 22.7259 19.5572 22.7415 19.0833C22.7727 18.3177 22.6113 17.8855 22.0594 17.2398C21.7053 16.8284 21.6741 16.4691 21.9552 16.1358C22.1375 15.9223 22.3406 15.8285 22.6113 15.8285C23.7829 15.8285 24.8347 14.9745 25.043 13.8548C25.1107 13.4903 25.1107 11.501 25.043 11.1365C24.8399 10.0481 23.7829 9.1628 22.6894 9.1628C22.3666 9.1628 22.1323 9.06386 21.9605 8.86076C21.6689 8.51185 21.7053 8.15774 22.075 7.73592C22.5697 7.1735 22.7675 6.67357 22.7623 5.99138C22.7623 5.51749 22.6165 5.0488 22.3614 4.66344C22.2625 4.51763 21.8147 4.02812 21.3564 3.58026C20.6223 2.85641 20.4817 2.73663 20.1172 2.56478C19.711 2.3721 19.6954 2.36689 19.081 2.36689C18.4718 2.36689 18.4457 2.3721 18.0656 2.55437C17.8521 2.65852 17.5553 2.8512 17.4096 2.98139C16.993 3.35634 16.665 3.42924 16.3473 3.21052C16.0505 3.00743 15.9776 2.86162 15.9256 2.36169C15.8683 1.78885 15.7746 1.49723 15.5194 1.10666C15.181 0.585899 14.6967 0.23699 14.0719 0.0755539C13.6553 -0.0338039 11.4996 -0.0285969 11.0935 0.0807629ZM13.848 1.76802C14.1031 1.89821 14.2645 2.18984 14.2645 2.51791C14.2645 3.11158 14.5353 3.78336 14.9414 4.21038C15.8683 5.17899 17.3627 5.24669 18.352 4.35619C18.4978 4.23121 18.6696 4.10102 18.7321 4.06457C18.8883 3.98125 19.2684 3.98125 19.4299 4.06457C19.5861 4.14789 20.742 5.27794 20.9347 5.53832C21.0544 5.69975 21.0857 5.7987 21.0857 5.99659C21.0857 6.30383 21.0388 6.40278 20.7368 6.73086C20.0078 7.5172 19.9089 8.76702 20.5025 9.70439C20.9138 10.3605 21.773 10.8292 22.5749 10.8292C22.9029 10.8292 23.1945 10.9907 23.3247 11.2458C23.4184 11.4281 23.4288 11.5479 23.4288 12.4957C23.4288 13.4434 23.4184 13.5632 23.3247 13.7455C23.1945 14.0007 22.9029 14.1621 22.5749 14.1621C21.773 14.1621 20.9138 14.6308 20.5025 15.2869C19.9089 16.2295 20.0078 17.4741 20.742 18.2709C21.0388 18.5885 21.0857 18.6875 21.0857 18.9895C21.0857 19.3072 21.044 19.3645 20.3359 20.0935C19.5652 20.8799 19.4194 20.984 19.0966 20.984C18.7894 20.984 18.6905 20.9372 18.3728 20.6403C17.5762 19.9061 16.3317 19.8071 15.3892 20.4008C14.7332 20.8122 14.2645 21.6714 14.2645 22.4734C14.2645 22.8015 14.1031 23.0931 13.848 23.2233C13.6657 23.317 13.546 23.3274 12.5983 23.3274C11.6506 23.3274 11.5309 23.317 11.3486 23.2233C11.0883 23.0931 10.9321 22.8015 10.9321 22.4578C10.9321 22.3224 10.8956 22.0568 10.854 21.8745C10.5468 20.5726 9.17732 19.7394 7.89641 20.0727C7.48505 20.1821 7.11015 20.38 6.82377 20.6403C6.50614 20.9372 6.40721 20.984 6.1 20.984C5.77717 20.984 5.63137 20.8799 4.86074 20.0935C4.15259 19.3645 4.11093 19.3072 4.11093 18.9895C4.11093 18.6875 4.1578 18.5885 4.4598 18.2605C4.74618 17.9532 4.97008 17.4845 5.0534 17.0158C5.31375 15.5577 4.12135 14.1621 2.62174 14.1621C2.2937 14.1621 2.00211 14.0007 1.87193 13.7455C1.77821 13.5632 1.76779 13.4434 1.76779 12.4905C1.76779 11.6312 1.78341 11.4125 1.8511 11.2667C1.99169 10.975 2.18956 10.8709 2.69984 10.824C3.58503 10.7407 4.18383 10.423 4.62122 9.79292C5.29292 8.82952 5.22523 7.55366 4.45459 6.72044C4.1578 6.40278 4.11093 6.30383 4.11093 5.99659C4.11093 5.7987 4.14218 5.69975 4.26194 5.53832C4.45459 5.27794 5.61054 4.14789 5.76675 4.06457C5.92817 3.98125 6.30828 3.98125 6.46449 4.06457C6.52697 4.09582 6.69359 4.23121 6.83418 4.35619C7.33926 4.82488 8.12031 5.06443 8.80763 4.95507C9.27105 4.88737 9.85423 4.60616 10.1666 4.29891C10.6353 3.84585 10.8592 3.34592 10.9269 2.60124C10.9737 2.08568 11.0727 1.893 11.359 1.7524C11.4996 1.67949 11.7235 1.66387 12.5879 1.66387C13.546 1.66387 13.6605 1.67429 13.848 1.76802Z"
              fill="currentColor"
            />
            <path
              d="M11.6603 6.74083C10.2232 6.96996 8.83815 7.80318 7.95817 8.96447C5.37551 12.3963 7.21357 17.2862 11.426 18.2027C12.3424 18.4006 13.4776 18.3381 14.4148 18.0309C15.3156 17.7393 16.3362 17.0727 16.935 16.3853C18.9241 14.1044 18.9241 10.8861 16.935 8.60515C16.4924 8.0948 15.8728 7.63133 15.175 7.28763C14.0399 6.72521 12.8892 6.54815 11.6603 6.74083ZM13.5869 8.44892C14.67 8.74575 15.5031 9.33942 16.0863 10.2351C17.1485 11.8599 16.9246 14.0262 15.5551 15.4115C13.6806 17.307 10.5669 16.9894 9.10891 14.7501C8.64549 14.0419 8.45804 13.4013 8.45804 12.4952C8.45804 11.5891 8.64549 10.9486 9.1037 10.2455C9.72333 9.29776 10.6866 8.6416 11.8165 8.40205C12.2331 8.31352 13.1808 8.33956 13.5869 8.44892Z"
              fill="currentColor"
            />
          </svg>
        </Link>
      </header>
      <Outlet />
      <footer className="fixed bottom-0 left-0 right-0 z-50 mt-8 px-6 py-3 flex justify-around items-center bg-gradient-to-r from-[#5716A9]/75 to-[#071D91]/75 bottom-tab">
        <Link to="/" className="flex flex-col items-center">
          <svg
            width="21"
            height="21"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.2,15L14.4,3.6c0,0,0.8-0.7,1.8,0.2s11.2,11.3,11.2,11.3"
              stroke="#fff"
            />
            <path
              d="M6,14.3v10.8c0,0-0.2,1.6,1.5,1.7s4.8,0,4.8,0s-0.7-4.5,2.7-4.8c0.8,0,3.8,0.1,3.2,4.8c2.2,0,4.9,0,4.9,0s1.5,0.2,1.5-1.7c0-1.8-0.1-10.8-0.1-10.8"
              stroke="#fff"
            />
            <path
              d="M3.2,15L14.4,3.6c0,0,0.8-0.7,1.8,0.2s11.2,11.3,11.2,11.3"
              stroke="#fff"
            />
            <path
              d="M6,14.3v10.8c0,0-0.2,1.6,1.5,1.7s4.8,0,4.8,0s-0.7-4.5,2.7-4.8c0.8,0,3.8,0.1,3.2,4.8c2.2,0,4.9,0,4.9,0s1.5,0.2,1.5-1.7c0-1.8-0.1-10.8-0.1-10.8"
              stroke="#fff"
            />
          </svg>
          <p className="text-xxs text-white mt-1">Home</p>
        </Link>
        <Link to="/Daily-wellbing" className="flex flex-col items-center">
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.2711 2.70352C10.0824 2.81836 9.10211 3.77813 8.75758 4.18418C8.59762 4.37695 8.35973 4.67637 8.22848 4.84863C8.08082 5.04141 7.97008 5.15625 7.94137 5.13984C7.91676 5.12344 7.70348 4.98398 7.46559 4.82813C6.94879 4.4918 5.80855 3.92168 5.19742 3.69609C4.40172 3.40078 4.3607 3.41719 3.94645 4.21289C3.44195 5.19316 3.06871 6.25957 2.86773 7.30137C2.79801 7.65 2.73648 7.95762 2.72828 7.98223C2.72008 8.01094 2.57242 8.01094 2.23199 7.97402C1.96129 7.94941 1.43629 7.9125 1.06305 7.89609C0.296055 7.86328 0.181211 7.88789 0.058164 8.12988C-0.0648829 8.36367 0.0417577 9.84844 0.246836 10.8738C0.792344 13.5604 2.36734 15.767 4.66422 17.059C6.43609 18.0557 9.03648 18.5273 11.6697 18.3346C14.5449 18.1172 16.7433 17.1861 18.3593 15.5004C20.0205 13.7613 20.8695 11.6285 20.9843 8.89277C21.0089 8.35137 21.0048 8.24473 20.9433 8.12988C20.8203 7.88789 20.7054 7.86328 19.9384 7.89609C19.5652 7.9125 19.0402 7.94941 18.7695 7.97402C18.4291 8.01094 18.2814 8.01094 18.2732 7.98223C18.265 7.95762 18.2035 7.65 18.1337 7.30137C17.9328 6.25957 17.5595 5.19316 17.055 4.21289C16.6408 3.41719 16.5998 3.40078 15.8041 3.69609C15.1929 3.92168 14.0527 4.4918 13.5359 4.82813C13.298 4.98398 13.0847 5.12344 13.0601 5.13984C13.0314 5.15625 12.9207 5.04141 12.773 4.84863C12.3587 4.29902 11.965 3.85195 11.4031 3.31055C10.8248 2.74863 10.6648 2.62559 10.5007 2.62559C10.4433 2.62559 10.3408 2.6625 10.2711 2.70352ZM11.0791 4.21289C11.7107 4.85684 11.965 5.16856 12.3957 5.8043C13.1627 6.94043 13.6384 8.10938 13.8845 9.45469C13.9871 10.0125 14.0117 11.2266 13.9296 11.8336C13.6836 13.6752 12.8879 15.2338 11.522 16.5545C11.1652 16.899 10.5623 17.3912 10.5007 17.3912C10.4392 17.3912 9.83629 16.899 9.47945 16.5545C8.11363 15.2338 7.31793 13.6752 7.07184 11.8336C6.9898 11.2266 7.01441 10.0125 7.11695 9.45469C7.41227 7.84688 8.08492 6.38672 9.13902 5.06602C9.37281 4.7707 10.4515 3.65098 10.5007 3.65098C10.5171 3.65098 10.7755 3.90527 11.0791 4.21289ZM5.86598 4.93477C6.33766 5.16035 7.25641 5.69356 7.5025 5.89043C7.5107 5.89863 7.42457 6.0791 7.30973 6.29238C6.90777 7.03887 6.59605 7.85508 6.41559 8.61387C6.36227 8.85176 6.30894 9.06914 6.29664 9.09785C6.28434 9.13477 6.2023 9.11016 6.00133 9.00762C5.39019 8.7041 4.39762 8.34727 3.86852 8.24473C3.5609 8.1832 3.565 8.21191 3.71266 7.48594C3.89312 6.58359 4.22125 5.61973 4.615 4.84043L4.79957 4.47539L5.17691 4.63125C5.38609 4.72148 5.69781 4.85684 5.86598 4.93477ZM16.3865 4.84043C16.7802 5.61973 17.1084 6.57949 17.2888 7.48594C17.4365 8.21191 17.4406 8.1832 17.1371 8.24473C16.6039 8.34727 15.6113 8.7041 15.0002 9.00762C14.7992 9.11016 14.7171 9.13477 14.7048 9.09785C14.6925 9.06914 14.6392 8.85176 14.5859 8.61387C14.4054 7.85508 14.0937 7.03887 13.6918 6.29238C13.5769 6.0791 13.4908 5.89863 13.499 5.89043C13.942 5.53359 15.4349 4.7502 16.1896 4.47539C16.1978 4.47129 16.2839 4.63535 16.3865 4.84043ZM1.97359 8.81895C2.94977 8.91328 3.69215 9.06504 4.43043 9.31113C5.02105 9.50801 5.27945 9.61875 5.76754 9.88945L6.14078 10.0945V10.8205C6.14898 12.6252 6.60836 14.1674 7.58043 15.6234C7.94957 16.1854 8.20387 16.4971 8.73297 17.0344L9.12672 17.4404L8.96266 17.4158C8.87242 17.4035 8.64273 17.3707 8.44996 17.3461C6.83395 17.141 5.34918 16.5627 4.15973 15.685C3.46656 15.1723 2.57652 14.1674 2.10074 13.3594C1.42398 12.2109 1.00973 10.7713 0.919492 9.26602L0.890781 8.77793H1.22301C1.40348 8.77793 1.7398 8.79844 1.97359 8.81895ZM20.082 9.26602C19.9918 10.7713 19.5775 12.2109 18.9007 13.3594C18.425 14.1674 17.5349 15.1723 16.8418 15.685C15.6523 16.5627 14.1675 17.141 12.5515 17.3461C12.3587 17.3707 12.1291 17.4035 12.0388 17.4158L11.8748 17.4404L12.2685 17.0344C12.7976 16.4971 13.0519 16.1854 13.4211 15.6234C14.3931 14.1674 14.8525 12.6211 14.8607 10.8205V10.0945L15.2339 9.88945C15.722 9.61875 15.9804 9.50801 16.5711 9.31113C17.5062 8.99941 18.7162 8.79434 19.7046 8.78203L20.1107 8.77793L20.082 9.26602Z"
              fill="white"
            />
          </svg>
          <p className="text-xxs text-white mt-1">Daily Wellbeing</p>
        </Link>
        <Link to="/start-scan" className="flex flex-col items-center">
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.51816 2.70781C3.71836 2.91699 3.06621 3.51172 2.7832 4.27871C2.69297 4.5207 2.68887 4.60273 2.67246 5.825L2.66016 7.11699L2.75449 7.26055C3.02109 7.6543 3.59121 7.6707 3.86191 7.29336C3.95215 7.16211 3.95625 7.1293 3.97676 6.00957C3.99727 4.91445 4.00137 4.85293 4.0957 4.64375C4.15312 4.5166 4.26797 4.36074 4.37461 4.2664C4.67812 3.9998 4.79297 3.9793 5.98652 3.9793C7.00781 3.9793 7.04473 3.97519 7.21699 3.88496C7.42207 3.77832 7.58613 3.51582 7.58613 3.30664C7.58613 3.08105 7.42207 2.82266 7.21699 2.71601C7.04062 2.62988 6.99551 2.62578 5.925 2.62988C4.97344 2.62988 4.77656 2.64219 4.51816 2.70781Z"
              fill="white"
            />
            <path
              d="M13.7793 2.71601C13.5742 2.82266 13.4102 3.08105 13.4102 3.30664C13.4102 3.51582 13.5742 3.77832 13.7793 3.88496C13.9516 3.97519 13.9885 3.9793 15.0098 3.9793C16.2033 3.9793 16.3182 3.9998 16.6217 4.2664C16.7283 4.36074 16.8432 4.5166 16.9006 4.64375C16.9949 4.85293 16.999 4.91445 17.0195 6.00957C17.04 7.1293 17.0441 7.16211 17.1344 7.29336C17.4051 7.6707 17.9752 7.6543 18.2418 7.26055L18.3361 7.11699L18.3238 5.825C18.3074 4.60273 18.3033 4.5207 18.2131 4.27871C18.0039 3.70859 17.5527 3.1918 17.0236 2.92109C16.5232 2.66269 16.2854 2.62578 15.0426 2.62578C14.0008 2.62578 13.9557 2.62988 13.7793 2.71601Z"
              fill="white"
            />
            <path
              d="M2.09902 9.91314C1.87344 10.0239 1.7832 10.192 1.7832 10.4997C1.7832 10.717 1.79961 10.7909 1.88164 10.8975C2.09082 11.1764 1.38535 11.1559 10.499 11.1559C19.6414 11.1559 18.9195 11.1764 19.1246 10.8934C19.2518 10.7129 19.2518 10.2864 19.1246 10.1059C18.9195 9.82291 19.6414 9.84341 10.4908 9.84341C2.96855 9.84341 2.22207 9.85162 2.09902 9.91314Z"
              fill="white"
            />
            <path
              d="M3.10354 13.4697C2.91487 13.5394 2.77132 13.6666 2.70569 13.8224C2.67288 13.9004 2.66468 14.3105 2.67288 15.2006C2.68929 16.3982 2.69339 16.4802 2.78362 16.7222C3.04612 17.44 3.59983 17.9732 4.37503 18.2603C4.59241 18.3424 4.70726 18.3506 5.82288 18.3629C7.02054 18.3793 7.03694 18.3793 7.21741 18.2849C7.42249 18.1783 7.58655 17.9199 7.58655 17.6943C7.58655 17.4851 7.42249 17.2226 7.21741 17.116C7.04515 17.0257 7.00823 17.0216 5.98694 17.0216C4.79339 17.0216 4.67854 17.0011 4.37503 16.7345C4.26839 16.6402 4.15354 16.4843 4.09612 16.3572C4.00179 16.148 3.99769 16.0865 3.97718 14.9914C3.95667 13.8716 3.95257 13.8388 3.86233 13.7076C3.69007 13.4697 3.37425 13.3713 3.10354 13.4697Z"
              fill="white"
            />
            <path
              d="M17.4591 13.4694C17.2868 13.531 17.1637 13.6294 17.0899 13.7606C17.0571 13.814 17.0325 14.2323 17.0202 14.9911C16.9997 16.0862 16.9956 16.1478 16.9012 16.3569C16.8438 16.4841 16.729 16.6399 16.6223 16.7343C16.3188 17.0009 16.204 17.0214 15.0104 17.0214C13.9891 17.0214 13.9522 17.0255 13.78 17.1157C13.419 17.3044 13.3165 17.7351 13.5462 18.0837C13.7348 18.3667 13.8333 18.3831 15.1991 18.3667C16.286 18.3503 16.405 18.3421 16.6223 18.2601C17.3975 17.9729 17.9512 17.4397 18.2137 16.722C18.304 16.48 18.3081 16.3979 18.3245 15.1757L18.3368 13.8837L18.2425 13.7401C18.0661 13.4817 17.7421 13.3669 17.4591 13.4694Z"
              fill="white"
            />
          </svg>
          <p className="text-xxs text-white mt-1">Vitals Scan</p>
        </Link>
        <Link to="/vouchers" className="flex flex-col items-center">
          <svg width="21" height="21" viewBox="0 0 5120 5120">
            <path
              d="M507 4230 c-173 -22 -315 -168 -338 -348 -11 -87 -11 -2557 0 -2644 24 -185 164 -325 347 -349 90 -11 3998 -11 4088 0 183 24 323 164 347 349 11 88 11 2557 0 2646 -24 183 -164 323 -349 347 -81 10 -4013 9 -4095 -1z m1093 -577 l0 -428 -183 183 c-170 170 -185 182 -219 182 -43 0 -68 -27 -68 -75 0 -25 27 -56 182 -212 l183 -183 -588 0 -587 0 0 390 c0 309 3 398 14 424 20 48 71 101 119 125 41 21 54 21 595 21 l552 0 0 -427z m3065 408 c46 -20 101 -79 121 -127 11 -26 14 -115 14 -424 l0 -390 -1467 0 -1468 0 183 183 c155 156 182 187 182 212 0 48 -25 75 -68 75 -34 0 -49 -12 -219 -182 l-183 -183 0 428 0 427 1433 0 c1363 0 1434 -1 1472 -19z m-3691 -1113 c-4 -7 -18 -27 -31 -44 -61 -81 -73 -223 -28 -322 34 -74 74 -114 147 -147 50 -23 73 -27 148 -26 138 0 238 32 343 108 l47 35 0 -756 0 -756 -564 2 -564 3 -43 30 c-24 17 -57 50 -74 74 l-30 43 -3 884 -2 884 330 0 c262 0 330 -3 324 -12z m623 -58 c-11 -132 -79 -235 -193 -291 -54 -27 -79 -33 -157 -37 -152 -8 -207 32 -207 151 0 64 14 99 57 138 83 77 188 108 372 108 l134 1 -6 -70z m525 41 c75 -24 141 -70 175 -120 31 -46 32 -141 3 -189 -31 -50 -77 -65 -186 -60 -69 4 -104 11 -146 30 -120 55 -194 162 -205 297 l-6 73 149 -4 c118 -4 163 -9 216 -27z m2678 -841 c0 -716 -2 -876 -14 -904 -20 -48 -75 -107 -121 -127 -38 -18 -109 -19 -1472 -19 l-1433 0 0 756 0 756 23 -16 c112 -82 179 -111 294 -125 237 -28 393 90 394 301 0 42 -7 92 -16 117 -15 42 -57 108 -79 123 -6 4 537 8 1207 8 l1217 0 0 -870z"
              fill="#fff"
            />
            <path
              d="M3263 2153 c-51 -10 -71 -93 -32 -129 20 -18 44 -19 529 -19 485 0 509 1 529 19 29 26 29 86 0 112 -20 18 -44 19 -513 20 -270 1 -501 0 -513 -3z"
              fill="#fff"
            />
            <path
              d="M3023 1593 c-51 -10 -71 -93 -32 -129 20 -18 46 -19 649 -19 603 0 629 1 649 19 29 26 29 86 0 112 -20 18 -46 19 -633 20 -336 1 -621 0 -633 -3z"
              fill="#fff"
            />
          </svg>
          <p className="text-xxs text-white mt-1">Vouchers</p>
        </Link>
        {/* <button
          type="button"
          onClick={viewRewards}
          className="flex flex-col items-center"
        >
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1361 0.0246105C11.2017 0.032814 11.4068 0.0615234 11.5872 0.086134C14.7454 0.49629 17.4443 2.8957 18.2318 5.98828C18.7034 7.83809 18.5271 9.72891 17.7232 11.4229C17.1777 12.5713 16.2384 13.7033 15.2253 14.4375L14.8069 14.741V17.6285C14.8069 20.4955 14.8069 20.5201 14.7208 20.6719C14.6224 20.8441 14.3845 21 14.2163 21C14.1548 21 14.0482 20.9754 13.9702 20.9426C13.8964 20.9139 13.0884 20.3848 12.1696 19.7736L10.5003 18.6621L8.83097 19.7736C7.91222 20.3848 7.10421 20.9139 7.03039 20.9426C6.95246 20.9754 6.84582 21 6.78429 21C6.61613 21 6.37824 20.8441 6.2798 20.6719C6.19367 20.5201 6.19367 20.4955 6.19367 17.6285V14.741L5.77121 14.4375C5.00832 13.8838 4.1757 12.9773 3.6507 12.1201C2.8796 10.865 2.45304 9.22031 2.51457 7.73145C2.6048 5.64375 3.4046 3.81445 4.86066 2.3584C6.07882 1.13613 7.53078 0.393751 9.26984 0.102539C9.64308 0.0410156 10.8777 -0.0123043 11.1361 0.0246105ZM9.83996 1.27559C7.69894 1.49297 5.84503 2.66191 4.7089 4.51172C4.35617 5.09004 4.01984 5.94316 3.87628 6.62402C3.6466 7.73555 3.71632 8.99473 4.06496 10.0611C4.74992 12.1529 6.34542 13.7484 8.43722 14.4334C9.74972 14.8641 11.2509 14.8641 12.5634 14.4334C14.6552 13.7484 16.2507 12.1529 16.9357 10.0611C17.3663 8.74863 17.3663 7.24746 16.9357 5.93496C16.5911 4.88086 16.0538 4.00313 15.2745 3.22383C13.8267 1.77598 11.8538 1.07051 9.83996 1.27559ZM12.5101 15.7295C11.7636 15.9182 11.3493 15.9674 10.5003 15.9674C9.45031 15.9674 8.65871 15.8361 7.76046 15.5039L7.42414 15.3809V17.3086V19.2363L8.83507 18.2971C9.61027 17.7803 10.2993 17.3455 10.3732 17.3291C10.4429 17.3168 10.5577 17.3168 10.6275 17.3291C10.7013 17.3455 11.3903 17.7803 12.1655 18.2971L13.5765 19.2363V17.3086V15.3809L13.2361 15.5039C13.0515 15.5736 12.7234 15.6762 12.5101 15.7295Z"
              fill="white"
            />
            <path
              d="M10.7868 3.16253C10.8647 3.21175 10.9591 3.28968 10.9919 3.33479C11.0247 3.37991 11.32 3.94593 11.6481 4.58987L12.2429 5.76292L13.5882 5.95569C14.3305 6.05823 14.9909 6.16897 15.0565 6.19358C15.2206 6.26331 15.3723 6.45198 15.4052 6.62835C15.4667 6.94827 15.4093 7.0221 14.3346 8.04339C13.7809 8.56839 13.3298 9.02366 13.3298 9.04827C13.3298 9.07698 13.4323 9.67581 13.5554 10.3854C13.6948 11.1729 13.7768 11.7225 13.7604 11.8045C13.7071 12.0916 13.3585 12.3418 13.0673 12.2926C12.9975 12.2803 12.3987 11.9932 11.7384 11.6528C11.0821 11.3123 10.5202 11.0334 10.4997 11.0334C10.4792 11.0334 9.91727 11.3123 9.26102 11.6528C8.60067 11.9932 8.00184 12.2803 7.93211 12.2926C7.6409 12.3418 7.29227 12.0916 7.23895 11.8045C7.22254 11.7225 7.30457 11.1729 7.44403 10.3854C7.56707 9.67581 7.66961 9.07698 7.66961 9.04827C7.66961 9.02366 7.21844 8.56839 6.66473 8.04339C5.59012 7.0221 5.5327 6.94827 5.59422 6.62835C5.62703 6.45198 5.77879 6.26331 5.94285 6.19358C6.00848 6.16897 6.66883 6.05823 7.41121 5.95569L8.75653 5.76292L9.35125 4.58987C9.67938 3.94593 9.97469 3.37991 10.0075 3.33479C10.1059 3.20354 10.3438 3.07639 10.4997 3.07639C10.5776 3.07639 10.7089 3.11741 10.7868 3.16253ZM10.0895 5.86956C9.69988 6.65296 9.54813 6.86214 9.33895 6.91136C9.28973 6.92366 8.87137 6.98518 8.4161 7.05081C7.95672 7.11643 7.57527 7.17796 7.56707 7.18616C7.56297 7.19436 7.82957 7.45686 8.1659 7.77268C8.50223 8.0885 8.81395 8.40432 8.85906 8.47405C8.90828 8.55198 8.9411 8.67093 8.9411 8.78167C8.9411 8.93343 8.74832 10.1557 8.67449 10.492C8.65399 10.5699 8.75653 10.5289 9.4866 10.1516C10.1716 9.79886 10.3561 9.72093 10.4997 9.72093C10.6432 9.72093 10.8278 9.79886 11.5128 10.1516C12.2429 10.5289 12.3454 10.5699 12.3249 10.492C12.2511 10.1557 12.0583 8.93343 12.0583 8.78167C12.0583 8.67093 12.0911 8.55198 12.1403 8.47405C12.1854 8.40432 12.4971 8.0885 12.8335 7.77268C13.1698 7.45686 13.4364 7.19436 13.4323 7.18616C13.4241 7.17796 13.0427 7.11643 12.5833 7.05081C12.128 6.98518 11.7096 6.92366 11.6604 6.91136C11.4513 6.86214 11.2995 6.65296 10.9098 5.86956C10.6966 5.43889 10.512 5.08616 10.4997 5.08616C10.4874 5.08616 10.3028 5.43889 10.0895 5.86956Z"
              fill="white"
            />
          </svg>
          <p className="text-xxs text-white mt-1">Rewards</p>
        </button> */}
        <Link to="/my-profile" className="flex flex-col items-center">
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.76101 2.03093C8.72741 2.2073 7.71022 2.76921 7.05397 3.528C5.45026 5.39421 5.5405 8.08484 7.25905 9.80339C8.97351 11.5178 11.6723 11.6081 13.5221 10.0167C14.0964 9.52449 14.6214 8.72468 14.8592 7.9946C15.5524 5.87 14.6091 3.54031 12.6403 2.51082C11.738 2.03914 10.7085 1.87097 9.76101 2.03093ZM11.0038 3.32703C12.7633 3.59773 13.9979 5.26296 13.7436 7.01433C13.3991 9.35632 10.7946 10.5868 8.78893 9.35222C7.6405 8.64675 7.02526 7.27683 7.27546 5.98074C7.61999 4.20886 9.24011 3.05632 11.0038 3.32703Z"
              fill="white"
            />
            <path
              d="M14.8181 10.5048C14.7238 10.55 14.6089 10.6484 14.5679 10.7181C14.3587 11.0668 14.4161 11.2923 14.8345 11.7435C15.7533 12.7443 16.3029 14.0158 16.389 15.3652C16.4259 15.9025 16.389 16.0091 16.0609 16.3168C14.8058 17.4898 11.1144 18.0394 8.01771 17.5103C6.6765 17.2847 5.49115 16.8295 4.96205 16.3414C4.61752 16.0173 4.5765 15.9107 4.60931 15.3898C4.69134 14.0486 5.24095 12.7443 6.13099 11.7845C6.45912 11.4236 6.53705 11.28 6.50834 11.0421C6.45912 10.6033 5.96283 10.3203 5.58549 10.5171C5.42963 10.5992 4.97845 11.075 4.68314 11.4769C3.84642 12.6048 3.36654 13.9625 3.29271 15.4021C3.2558 16.1814 3.39525 16.5875 3.89154 17.1166C5.65111 18.9869 11.0857 19.6226 14.8427 18.3921C15.8722 18.0558 16.6228 17.6293 17.1109 17.1084C17.6031 16.5875 17.7425 16.1814 17.7056 15.4021C17.6154 13.6712 16.9222 12.0306 15.7738 10.833C15.3636 10.4064 15.1585 10.3367 14.8181 10.5048Z"
              fill="white"
            />
          </svg>
          <p className="text-xxs text-white mt-1">My Profile</p>
        </Link>
      </footer>
    </main>
  );
};
const Layout = ({ children }) => {
  return (
    <>
      <ScrollRestoration />
      {children}
    </>
  );
};
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <Layout />
        <Header />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: "my-account", element: <MyAccount /> },
      { path: "tutorial", element: <Tutorial /> },
      { path: "support", element: <Support /> },
      { path: "start-scan", element: <StartScan /> },
      { path: "select-scan", element: <SelectScanOption /> },
      // { path: "select-option", element: <SelectOption /> },
      { path: "scan-instructions", element: <ScanInstructions /> },
      { path: "camera-permission-guide", element: <CameraPermissionGuide /> },
      // { path: "select-posture", element: <SelectPosture /> },
      { path: "scan-result", element: <ScanResult /> },
      { path: "survey", element: <Survey /> },
      { path: "vouchers", element: <Vouchers /> },
      { path: "Abha-Details", element: <Abha /> },
      { path: "Lab-packages", element: <LabPackages /> },
      { path: "lab-package-detail", element: <LabPackageDetail /> },
      { path: "Doctor-list", element: <DoctorList /> },
      { path: "Doctor-appointment", element: <DoctorAppointment /> },
      { path: "Education", element: <Education /> },
      { path: "Education-details", element: <EducationDetails /> },
      { path: "Wellness-program", element: <WellnessProgram /> },
      { path: "Join-program", element: <JoinProgram /> },
      { path: "Medication", element: <Medication /> },
      { path: "Nutrition", element: <Nutrition /> },
      { path: "Activity", element: <Activity /> },
      { path: "Walking", element: <Walking /> },
      { path: "Walking-details", element: <WalkingDetails /> },
      { path: "bmi", element: <BMI /> },
      { path: "mental-wellbing", element: <MentalWellbing /> },
      { path: "Daily-wellbing", element: <DailyWellbing /> },
      { path: "Wellbing-details", element: <WellbingDetails /> },
      { path: "Health-hebits", element: <HealthHabbits /> },
      { path: "Health-details", element: <HealthDetails /> },
      { path: "Rewards", element: <Reward /> },
      { path: "Live-chat", element: <LiveChat /> },
      { path: "vitals-index", element: <VitalsIndex /> },
      { path: "heart-score", element: <HeartHealthScore /> },
      { path: "diabetes-insight", element: <DiabetesInsights /> },
      { path: "my-care", element: <MyCare /> },
      // { path: "Breath-lab", element: <BreathLab /> },
      { path: "Package-list", element: <PackageList /> },
      { path: "Package-details", element: <PackageDetails /> },
      { path: "Insurance-list", element: <InsuranceList /> },
      // { path: "Back-pain", element: <BackPain /> },
      // { path: "Period-cramps", element: <PeriodCramps /> },
      // { path: "Migraine-pain", element: <MigrainePain /> },
      { path: "score-history", element: <ScoreHistory /> },
      // { path: "Headache-pain", element: <Headache /> },
      // { path: "Shoulder-pain", element: <ShoulderPain /> },
      // { path: "Knee-pain", element: <KneePain /> },
      { path: "my-health", element: <MyHealth /> },
      { path: "score-details", element: <ScoreDetails /> },
      { path: "My-mind", element: <MyMind /> },
      { path: "discount-center", element: <DiscountCenter /> },
      { path: "bmi-history", element: <BmiHistory /> },
      { path: "vitals-score", element: <VitalsScore /> },
      { path: "health-challenge", element: <HealthChallenge /> },
      { path: "mood-insight", element: <MoodInsight /> },
      { path: "mood-history", element: <MoodHistory /> },
      { path: "better-sleep", element: <BetterSleep /> },
      { path: "content-details", element: <ContentDetails /> },
      { path: "content-tabs", element: <ContentTabs /> },
      { path: "bedtime-story", element: <BedtimeStory /> },
      { path: "bedtime-melody", element: <BedtimeMelody /> },
      { path: "relaxing-music", element: <RelaxingMusic /> },
      { path: "fitness-package", element: <FitnessPackage /> },
      { path: "nutrition-package", element: <NutritionPackage /> },
      { path: "nutrition-package-list", element: <NutritionPackageList /> },
      { path: "bedtime-stretching", element: <BedtimeStretching /> },
      { path: "wellbing", element: <Wellbeing /> },
      // { path: "self-care", element: <SelfCare /> },
      // { path: "managing-stress", element: <ManagingStress /> },
      // { path: "personal-growth", element: <PersonalGrowth /> },
      // { path: "increasing-work", element: <IncreasingWorkLife /> },
      // { path: "emotional-resilience", element: <EmotionalResilience /> },
      { path: "mindful-moments", element: <MindfulMoments /> },
      { path: "relaxation-music", element: <RelaxationMusic /> },
      { path: "yoga-meditation", element: <YogaMeditation /> },
      { path: "visualization", element: <VisualizationTranquility /> },
      { path: "wellbeing-detail", element: <WellbeingContentDetails /> },
      { path: "our-pricing", element: <OurPricing /> },
      { path: "mood-step", element: <MoodtrackStep /> },
      { path: "insurance-policy", element: <InsurancePolicy /> },
      { path: "relive-pain", element: <RelivePain /> },
      { path: "nutration-list", element: <NutrationList /> },
      { path: "nutration-recipes-list", element: <NutritionReceipesList /> },
      { path: "nutration-recipe-detail", element: <NutritinReceipeDetail /> },
      { path: "do-you-know", element: <DYKList /> },
      { path: "dyk-detail", element: <DYKDetails /> },
      { path: "configure-alerts", element: <ConfigureAlerts /> },
      { path: "alert-select-user", element: <SelectUserAlert /> },
      { path: "alert-setting", element: <AlertSetting /> },
      { path: "diagnostic-packages", element: <DiagnosticPackages /> },
      { path: "doctor-consultation", element: <DoctorConsultation /> },
      { path: "goal", element: <Goal /> },
      { path: "add-goal", element: <AddGoal /> },
      { path: "selected-goal", element: <SelectedGoal /> },
      { path: "cognitive-score", element: <CognitiveScore /> },
      { path: "cognitive-assessment", element: <CognitiveAssessments /> },
      { path: "simon-test", element: <SimonTest /> },
      { path: "simon-circle", element: <SimonTestCircle /> },
      { path: "simon-score", element: <SimonScore /> },
      { path: "nutrition-results", element: <NutritionResults /> },
      { path: "water-tracker", element: <WaterTracker /> },
      { path: "nutrition-history", element: <NutrationHistory /> },

      {
        path: "history",
        children: [
          { index: true, element: <DetailHistory /> },
          { path: "heart-health", element: <HeartHealth /> },
          { path: "body-vitals", element: <BodyVitals /> },
          { path: "physio-fitness", element: <PhysioFitness /> },
          { path: "stress-index", element: <StressIndex /> },
        ],
      },
    ],
  },
  {
    path: "mood-tracking",
    element: (
      <AuthProvider>
        <Layout />
        <MoodTracking />
      </AuthProvider>
    ),
  },
  {
    path: "select-user",
    element: (
      <AuthProvider>
        <Layout />
        <SelectUser />
      </AuthProvider>
    ),
  },
  {
    path: "request-callback",
    element: (
      <AuthProvider>
        <Layout />
        <RequestCallback />
      </AuthProvider>
    ),
  },
  {
    path: "my-profile",
    element: (
      <AuthProvider>
        <Layout />
        <MyProfile />
      </AuthProvider>
    ),
  },
  // { path: "Analysis-Data", element: <AnalysisData /> },
  // { path: "creating-program", element: <ProgramTracking /> },
  // { path: "traking-success", element: <TrakingSuccess /> },
  // { path: "terms-of-use", element: <TermsOfUSe /> },
  // { path: "privacy-policy", element: <PrivacyPolicy /> },
  {
    path: "terms-of-use",
    element: (
      <Layout>
        <TermsOfUSe />
      </Layout>
    ),
  },
  {
    path: "privacy-policy",
    element: (
      <Layout>
        <PrivacyPolicy />
      </Layout>
    ),
  },
  {
    path: "face-scan",
    element: (
      <AuthProvider>
        <Layout />
        <FaceScan />
      </AuthProvider>
    ),
  },
  {
    path: "finger-scan",
    element: (
      <AuthProvider>
        <Layout />
        <FingerScan />
      </AuthProvider>
    ),
  },
  {
    path: "digital-clinic",
    element: (
      <AuthProvider>
        <DigitalClinic />
      </AuthProvider>
    ),
  },
  {
    path: "basic-details",
    element: (
      <AuthProvider>
        <Layout />
        <BasicDetails />
      </AuthProvider>
    ),
  },
  {
    path: "/referview",
    element: (
      <AuthProvider>
        <Layout />
        <AuthBypass />
      </AuthProvider>
    ),
  },
  {
    path: "/login",
    element: (
      <AuthProvider>
        <Layout />
        <Login />
      </AuthProvider>
    ),
  },
  {
    path: "referal",
    element: (
      <AuthProvider>
        <Layout />
        <Referal />
      </AuthProvider>
    ),
  },
  { path: "download", element: <DownloadAPP /> },
  // { path: "*", element: <NotFound /> },
  {
    path: "*",
    element: (
      <Layout>
        <NotFound />
      </Layout>
    ),
  },
]);

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return <RouterProvider router={router} />;
};

export default App;
